import { DETAIL_DATA } from '@/data/portfolio/portfolio-detail-data';
import './portfolio-next-banner.scss';
import {
	PORTFOLIO_LIST_DATA,
	PortfolioName
} from '@/data/portfolio/portfolio-list-data';
import useDeviceSize from '@/hooks/useDeviceSize';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import Image from '@/components/Image/image';
import { motion } from 'motion/react';
import { Button } from '@/components/shadcn/button/button';
import { useRouter } from '@/hooks/useRouter';
const PortfolioNextBanner = () => {
	const router = useRouter();
	const { name } = useParams() as { name: PortfolioName };
	const currentIndex = PORTFOLIO_LIST_DATA.findIndex(
		(item) => item.link === name
	);

	const filteredCurrentIndex = currentIndex === -1 ? 0 : currentIndex;

	// 다음 컨텐츠 인덱스
	const nextIndex =
		currentIndex < PORTFOLIO_LIST_DATA.length - 1
			? filteredCurrentIndex + 1
			: 0;
	const nextPortfolioName = PORTFOLIO_LIST_DATA[nextIndex].link;

	const nextPortfolio = DETAIL_DATA[nextPortfolioName];

	const { backgroundImage, logoImage, logoSize } = nextPortfolio.banner;
	const { deviceSize } = useDeviceSize();

	const convertedLogoSize = useMemo(() => {
		if (deviceSize === 'pc') {
			return logoSize.pc;
		}
		if (deviceSize === 'tablet') {
			return logoSize.tablet;
		}
		if (deviceSize === 'mobile') {
			return logoSize.mobile;
		}
		return logoSize.pc;
	}, [deviceSize, logoSize]);

	const handleClickNext = () => {
		router.push(`/portfolio/${nextPortfolioName}`);
	};
	return (
		<div className="portfolio-next-banner-wrapper">
			<div className="image-shader" />

			<Image
				className="banner-img"
				src={backgroundImage}
				alt={logoImage}
				draggable={false}
			/>
			<div className="banner-content-box">
				<motion.div
					initial={{ opacity: 0, y: 50 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, ease: 'easeOut' }}
					className="banner-title-wrapper"
				>
					<img
						className="banner-logo"
						src={logoImage}
						alt={logoImage}
						draggable={false}
						width={convertedLogoSize.width * 0.5}
						height={convertedLogoSize.height * 0.5}
					/>
					<Button
						variant="secondary"
						size="md-round"
						onClick={handleClickNext}
					>
						{/* <ArrowRightIcon className="w-4 h-4" /> */}
						포트폴리오 보기
					</Button>
				</motion.div>
			</div>
		</div>
	);
};

export default PortfolioNextBanner;
